<template>
	<div class="danger">
		<van-cell-group class="navShow">
			<van-row>
				<van-col :span="2">
					<van-icon name="arrow-left" color="#fff" @click="goBack" />
				</van-col>
				<van-col :span="20">安全措施</van-col>
				<van-col :span="2"></van-col>
			</van-row>
		</van-cell-group>
		<van-row class="elRow">
			<div style='clear:both'>
				<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class='vant-clearfix' offset='0'
				 :immediate-check="false">
					<div class="elCol elColRow" v-for="(item,index) in listData" :key='index'>
						<div class="colContent" style='height:calc(100% - 55px);background:none;' @click="detailItem(item)">
							<ul class='dataUl'>
								<!-- <li>
									<span class='textTitlet'><i class='circle'></i>安全确认编号:</span>
									<span class='textCon'>{{item.DHZYAQQRB_AQQRBGBH}}</span>
								</li> -->
								<li>
									<span class='textTitlet'><i class='circle'></i>安全措施编制时间:</span>
									<span class='textCon'>{{item.DHZYAQCSB_CJSJ}}</span>
								</li>
								<li>
									<span class='textTitlet'><i class='circle'></i>安全措施编制人:</span>
									<span class='textCon'>{{item.DHZYAQCSB_BZR}}</span>
								</li>
								<!-- <li class='arrowLi'>
									<van-icon :class="'down'+index" name="arrow-down" @click="showDiv(index)" />
									<van-icon :class="'up'+index" v-show='false' name="arrow-up" @click="hiddenDiv(index)" />
								</li> -->
							</ul>
						</div>
					</div>
				</van-list>
				<div class="addCon" v-if="isCyr" @click="newAdd">
					<span></span>
				</div>
			</div>
		</van-row>
	</div>
</template>

<script>
	export default {
		name: 'safetyMeasuresList',
		props: {},
		data() {
			return {
				loading: false,
				finished: false,
				getTable: {
					limit: 10,
					page: 1,
				},
				count: 0,
				listData: [],
				baseUrl: sessionStorage.getItem('baseURL'),
				row:null,
				fieldButtonParamList:[],
				stage:'',
				isCyr:false
			}
		},

		components: {
		},

		created() {
			this.row = JSON.parse(sessionStorage.getItem('routeParams1'));
			for(var k in this.row) {
				if(k.indexOf('AQQRB_') != -1){
					this.row[k] = "";
				}
			}
			let rowa = this.row;
			var rowStr = JSON.stringify(rowa);
			var userid = sessionStorage.getItem('userId');
			if(~rowStr.indexOf(userid)<0){
				this.isCyr = true;
			}else{
				this.isCyr = false;
			}
			var id = this.$route.params.dangerid //危险作业id
			this.selectSafetyMeasures(id)
		},

		mounted() {

		},
		destroyed() {
			//sessionStorage.removeItem('fieldButtonParamList');
		},
		methods: {
			//查看
			detailItem:function(row){
				let that = this;
				let obj = {
				  businessKey: row.id, //当前数据的id
				  userId: sessionStorage.getItem("userId"), //当前登录用户的id
				  isMobile: 1, //手机端 1  pc  0
				  isNext: 0 // 编辑 0  下一步 1
				};
				this.$axios.post("/dform/firework/getFireWorkForm", obj).then(res => {
				  if (res.data.code) {
				    row.inputFormId = res.data.data.formKey;
				    row.detailState = true;
				    let stage = res.data.data.stage;
					stage == "安全措施";
					row.name = "安全措施";
					row.inputFormId = "391a943a-279b-a111-8c28-76c1003fbf32";
					sessionStorage.setItem("stage",stage);
				    let fieldButtonParam = [];
					that.stage = stage;
				    sessionStorage.setItem(
				      "detailParams",
				      JSON.stringify({ formData: row, fieldButtonParam})
				    );
				    this.$router.push({
				      name:'safetyMeasures',
				      params: { formData: row, fieldButtonParam }
				    });
				  }
				});
			},
			//新增
			newAdd() {
				let that = this;
				that.fieldButtonParamList = JSON.parse(sessionStorage.getItem('fieldButtonParamList'));
				let row = that.row;
				let obj = {
				  businessKey: row.id, //当前数据的id
				  userId: sessionStorage.getItem("userId"), //当前登录用户的id
				  isMobile: 1, //手机端 1  pc  0
				  isNext: 0 // 编辑 0  下一步 1
				};
				this.$axios.post("/dform/firework/getFireWorkForm", obj).then(res => {
				  debugger
				  if (res.data.code) {
				    row.inputFormId = res.data.data.formKey;
				    row.detailState = false;
				    let stage = res.data.data.stage;
					stage == "安全措施";
					row.name = "安全措施";
					row.inputFormId = "391a943a-279b-a111-8c28-76c1003fbf32";
					sessionStorage.setItem("stage",stage);
				    let fieldButtonParam = that.fieldButtonParamList.filter(
				      item => item.inputForm == "391a943a-279b-a111-8c28-76c1003fbf32"
					);
				    that.stage = stage;
					for(var k in row) {
						if(k.indexOf('AQCSB_') != -1){
							row[k] = "";
						}
					}
				    sessionStorage.setItem(
				      "detailParams",
				      JSON.stringify({ formData: row, fieldButtonParam })
				    );
				    this.$router.push({
				      name:'safetyMeasures',
				      params: { formData: row, fieldButtonParam }
				    });
				  }
				});
			},
			//上拉加载更多数据
			onLoad() {
				//this.getWorkUserInfoById()
			},
      selectSafetyMeasures(id) {
				let obj = {id:id}
				this.$axios.post('/dform/index/selectSafeConfirmAQCS', obj).then((res) => {
					if (res.data.code) {
						this.loading = false
						let rows = res.data.data.row;
						this.listData = this.listData.concat(rows);
						this.finished = true;
					}
				})
			},
			goBack() {
				sessionStorage.removeItem('fieldButtonParamList');
				this.$router.go(-1)
			},
		},

		computed: {

		},

		watch: {

		},

	}
</script>

<style scoped>
	.elColRow {
		width: 98%;
		margin-left: 1%;
		border-radius: 5px;
		height: auto;
		background: #fff;
		padding: 10px;
		text-align: center;
	}

	.elCol {
		margin-bottom: 5px;
		height: 42.5%;
	}

	.typeBox,
	.stateBox {
		padding: 0 5px 8px;
	}

	.typeBox .num {
		color: #74aefb;
	}

	.stateBox .num {
		color: #ffc63c;
	}

	.typeBox div,
	.stateBox div {
		height: 70px;
		background: #f1f7ff;
		border-radius: 5px;
		padding-top: 10px;
	}

	.stateBox div {
		background: #fff9eb;
	}

	.elCol .num {
		font-size: 17px;
		font-weight: bold;
	}

	.elCol span:nth-of-type(2) {
		font-size: 13px;
		display: block;
		margin-top: 8px;
	}

	.num1 {
		color: #55dbb1;
	}

	.num2 {
		color: #eb6100;
	}

	.num3 {
		color: #fec42c;
	}

	.num4 {
		color: #74aefb;
	}

	.navShow {
		background: linear-gradient(45deg, #46b6e9, #05469c);
		width: 100%;
		height: 1.25rem;
		line-height: 1.25rem;
		z-index: 1;
	}

	.navShow .van-row {
		height: 100%;
	}

	.navShow .van-row .van-col {
		height: 100%;
		text-align: center;
		color: #fff;
		font-size: 0.45rem;
		font-weight: bold;
	}

	.logo img {
		width: auto;
		height: 70%;
		position: relative;
		top: 20%;
	}

	.text {
		position: absolute;
		text-align: center;
	}

	.elRow {
		height: calc(100% - 45px);
		width: 100%;
		overflow-y: auto;
	}

	.elCol {
		margin-bottom: 5px;
		height: auto;
		background: #fff;
		padding: 10px;
		text-align: center;
	}

	.colBox {
		background: #fff;
		height: 100%;
	}

	.colHeader {
		height: 30px;
		line-height: 30px;
		display: flex;
		align-items: center;
		position: relative;
	}

	.colHeader strong {
		color: red;
	}

	.colHeader img {
		width: 25px;
		height: auto;
		margin-right: 8px;
	}

	.colHeader .more {
		font-size: 12px;
		position: absolute;
		right: 10px;
	}

	.colContent {
		height: calc(100% - 30px);
		background: #fff;
		margin: 10px 0 5px;
		overflow: hidden;
	}

	.dataUl li {
		display: flex;
		padding: 5px;
	}

	.dataUl li .textTitlet {
		display: inline-block;
		width: 135px;
		color: #646566;
		font-size: 14px;
		line-height: 24px;
		text-align: left;
	}

	.dataUl li .textCon {
		display: inline-block;
		width: calc(100% - 115px);
		color: #323233;
		font-size: 14px;
		line-height: 24px;
		text-align: left;
		margin-top: 0;
	}

	.dataUl .arrowLi {
		justify-content: center;
		color: #bbb;
		padding: 0;
	}

	.search>div {
		width: 90%;
		margin: 0 auto 6px;
	}

	.search .inp>span {
		display: inline-block;
		width: 100px;
		text-align: left;
		font-size: 14px;
	}

	.search .inp>div {
		display: inline-block;
		width: calc(100% - 110px);
	}

	.search input {
		width: 100%;
		padding: 5px 8px;
		border-radius: 4px;
		border: 1px solid #ddd;
	}

	.search .van-button {
		width: 90px;
		height: 40px;
		line-height: 40px;
		margin: 0 15px;
		background: linear-gradient(45deg, #46b6e9, #05469c);
		border: none;
	}

	.colContent>>>.spot-child {
		position: relative;
	}

	.colContent>>>.spot-child {
		position: relative;
	}

	.colContent>>>.el-progress--circle .el-progress__text,
	.colContent>>>.el-progress--dashboard .el-progress__text {
		top: 40%;
	}

	.colContent>>>.spot-child .el-progress__text {
		font-size: 18px !important;
	}

	.colContent>>>.spot-child:first-child .el-progress__text {
		color: #74AEFB;
	}

	.colContent>>>.spot-child:nth-child(2) .el-progress__text {
		color: #FFC63C;
	}

	.colContent>>>.spot-child:last-child .el-progress__text {
		;
		color: #FF7859;
	}

	.notes {
		position: absolute;
		bottom: 35%;
		left: 28%;
	}

	.work-statistics {
		width: 96%;
		margin-left: 4%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.work-statistics .work-child {
		width: 50%;
		margin-top: 10px;
	}

	.work-statistics .work-child>>>.el-progress__text {
		display: none;
	}

	.work-statistics .work-child>>>.el-progress-bar {
		padding-right: 24px;
	}
</style>
